<template>
  <div class="box">
    <!-- 反馈快递单号 -->
    <div class="container">
      <!-- <div class="item_input">
            <div class="left">
                <span class="orderNum">快递单号</span>
                <input type="text" class="name" placeholder="请填写快递单号" v-model="num"/>
                <span class="searchNum" @click="searchOrder">查询</span>
            </div>
      </div>-->
      <div class="about_order line_bottom">
        <p class="orderNum">快递单号<span class="xinghao">*</span></p>
        <input type="text" class="name" placeholder="请填写快递单号" v-model="num" />
        <p class="searchNum" @click="searchOrder">查询</p>
      </div>
      <div class="item line_bottom" @click="showType">
        <div class="left">
          <span class="wuliugongsi">物流公司</span>
          <span class="result_style">{{typeValue}}</span>
        </div>
          <van-icon class="arrow" name="arrow" />
      </div>
      <div class="result">
        <span class="info">补充说明</span> <span style="font-family: PingFangSC-Regular;font-size: 14px;color:red;margin-left: 3px;">*</span> 
        <!-- <textarea class="content" placeholder="请输入" v-model="content"></textarea> -->
        <van-field
          class="my-textarea"
          v-model="content"
          autosize
          type="textarea"
          placeholder="请输入"
          show-word-limit
          maxlength="500"
        />
      
      </div>
      <!-- <div class="btn" v-if="isOriginHei">
        <span @click="confirm" :class="{'active':change}">确定</span>
      </div> -->
      <common-picker
        ref="commonPicker"
        :typeList="typeList"
        :cols="cols1"
        @getTypeValue="getTypeValue"
      ></common-picker>
    </div>
    <div class="btn" v-if="isOriginHei">
      <span @click="confirm" :class="{'active':change}">确定</span>
    </div>
  </div>
</template>
<script>
import util from "../../../../utils/common";
import api from "../../../../service/modules/refund.js";
import commonPicker from "../../../../components/base/commonPicker";
import { channer } from "../../../../utils/configJson";
import { storageGetByName } from '../../../../utils/helper';
export default {
  components: {
    commonPicker
  },
  data() {
    return {
      title1: "反馈快递单号",
      typeValue: "点击查询自动识别物流公司",
      typeList: channer,
      code: "",
      content: "",
      flowId: this.$router.currentRoute.query.flowId,
      orderNumber: this.$router.currentRoute.query.number,
      num: "",
      cols1: 1,
      isOriginHei: true,
      documentHeight: document.documentElement.clientHeight, // 默认屏幕高度
      imageList: {
        reader0: []
      },
      isViewerShow: false,
      viewerIndex: 0,
      isFlag: true
      // orgId:this.$store.state.userInfo.orgId,
    };
  },
  computed: {
    change() {
      if ((this.code !== "") & (this.content.trim().length > 0)) {
        return true;
      } else {
        return false;
      }
    }
  },
  async beforeMount() {
    // 获取快递配置列表
    let config = await storageGetByName('configList')
    var list = []
    config.EXPRESS_TYPE.map((item, index) => {
        list.push({ text: item.name, value: index, code: item.code });
      });
    this.typeList = []
    this.typeList.push(list)
    // 初始化选择器
    setTimeout(() => {
        this.$refs.commonPicker._initFresh();
    }, 50);
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        if (this.documentHeight > document.documentElement.clientHeight) {
          this.isOriginHei = false;
        } else {
          this.isOriginHei = true;
        }
      })();
    };
  },
  created() {
    // this.getType();
  },
  methods: {
    searchOrder() {
      // 调用查询物流公司的接口
      if (this.num.trim().length === 0) {
        this.$Toast({
          message: "请填写快递单号"
        });
      } else {
        this.getOrderDistinguish();
      }
    },

    showViewer(index) {
      this.viewerIndex = index;
      this.isViewerShow = true;
    },

    getType() {
      var type = util.getJsonLocal("configList").EXPRESS_TYPE;
      let list = [];
      type.map((item, index) => {
        list.push({ text: item.name, value: index, code: item.code });
      });
      this.typeList = [];
      this.typeList.push(list);
      setTimeout(() => {
        this.$refs.commonPicker._initFresh();
      }, 50);
    },
    showType() {
      this.$refs.commonPicker.showPicker();
    },
    getTypeValue(value) {
      this.typeValue = value[0].text;
      this.code = value[0].code;
    },
    confirm() {
      if (this.code === "") {
        this.$Toast({
          message: "请选择物流公司"
        });
      } else if (this.num.trim().length === 0) {
        this.$Toast({
          message: "请输入快递单号"
        });
      } else if (this.content.trim().length === 0) {
        this.$Toast({
          message: "请填写补充原因"
        });
      } else {
        if (this.isFlag) {
          this.getFlow();
          this.isFlag = false;
        }
      }
    },
    getOrderDistinguish() {
      api.orderDistinguish({ expNo: this.num }).then(res => {
        console.log(res);
        if (res.ret === 0) {
          // 查询成功
          if (res.data) {
            this.typeValue = JSON.parse(res.data).Shippers[0].ShipperName;
            this.code = JSON.parse(res.data).Shippers[0].ShipperCode;
          }
        } else {
          this.$Toast({
            message: "没有查询到物流公司~"
          });
        }
      });
    },
    getFlow() {
      api
        .express({
          flowId: this.flowId,
          content: this.content,
          expressCompany: this.code,
          expressNo: this.num,
        })
        .then(res => {
          if (res.ret === 0) {
            this.$Toast({
              message: res.msg
            });
            this.isOriginHei = false;
            setTimeout(() => {
              this.$router.back();
            }, 1500);
          } else {
            this.$Toast({
              message: res.msg
            });
          }
        });
    }
  }
};
</script>
<style scoped  lang="less">
.box {
  width: 100%;
  .container {
    width: 100%;
    height: 100%;
    // height:100vh;
    padding: 0px 16px 90px;
    .item {
      display: flex;
      display: -webkit-flex;
      padding: 22px 0;
      justify-content: space-between;
      -webkit-justify-content: space-between;
      .van-icon-arrow:before {
        font-size: 12px;
      }
      .left {
        .wuliugongsi::after {
          content: '*';
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #F94F4E;
          margin-left: 3px;
        }
        span:nth-child(1) {
          display: inline-block;
          width: 80px;
        }
        span {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #666666;
        }
        .result_style {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #171A1D;
        }
      }
      .back {
        width: 6px;
        height: 12px;
      }
    }
    .about_order {
      width: 100%;
      display: flex;
      display: -webkit-flex;
      align-items: center;
      align-items: center;
      padding: 16px 0;
      box-sizing: border-box;
      overflow: hidden;
      .searchNum {
        display: inline-block;
        width: 30px;
        text-align: center;
        line-height: 30px;
        padding: 0 14px;
        background-color: @base-color;
        font-size: 14px;
        border-radius: 4px;
        color: #fff;
      }
      .orderNum {
        font-size: 14px;
        width: 80px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        .xinghao {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #F94F4E;
          margin-left: 3px;
        }
      }
      .name {
        border: 0;
        width: 53%;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #171A1D;
        }

      .name::-webkit-input-placeholder {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #CCCCCC;
        line-height: 14px;
        }
        //Firefox版本4-18 
        .name:-moz-placeholder {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;line-height: 14px;
          color: #CCCCCC;
        }
        //Firefox版本19+
        .name::-moz-placeholder {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;line-height: 14px;
          color: #CCCCCC;
        }
        //IE浏览器
        .name:-ms-input-placeholder {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;line-height: 14px;
          color: #CCCCCC;
        }
      
    }
    .item_input {
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      -webkit-justify-content: space-between;
      border-bottom: 1px solid #efefef;
      padding: 10px 0;
      align-items: center;
      .left {
  
        .orderNum {
          display: inline-block;
          font-size: 14px;
          width: 80px;
          color: #666666;
            .name {
              height: 40px;
              border: 0;
              outline: none;
              font-size: 14px;
              // color:#D4D4D4;
            }
            .name::-webkit-input-placeholder { /* WebKit browsers */
              font-family: PingFangSC-Regular;
              font-weight: 400;
              font-size: 14px;
              color: #CCCCCC;
              }

              .name:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
              font-family: PingFangSC-Regular;
              font-weight: 400;
              font-size: 14px;
              color: #CCCCCC;
              }

              .name::-moz-placeholder { /* Mozilla Firefox 19+ */
              font-family: PingFangSC-Regular;
              font-weight: 400;
              font-size: 14px;
              color: #CCCCCC;
              }

              .name:-ms-input-placeholder { /* Internet Explorer 10+ */
              font-family: PingFangSC-Regular;
              font-weight: 400;
              font-size: 14px;
              color: #CCCCCC;
              }
        }
        .result_style {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #171A1D;
        }
        .searchNum {
          display: inline-block;
          // padding:8px 14px;
          width: 60px;
          text-align: center;
          line-height: 60px;
          background-color: @base-color;
          font-size: 14px;
          color: #fff;
          border-radius: 4px;
          // margin-left:8px;
          background-color: pink;
        }
      }
    }
    .result {
      .info {
        display: inline-block;
        padding: 22px 0;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
      }
      /deep/.my-textarea {
        background: #F8F9FB;
        border-radius: 4px;
        padding: 16px 4px 16px 16px;
        .van-field__control {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #1E2226;
          min-height: 160px;
          max-height: 360px;
        }
         .van-field__control::-webkit-scrollbar {
              width: 3px;
          }
          .van-field__control::-webkit-scrollbar-thumb {
              background: #E4E5E8;
          }
          .van-field__control::-webkit-scrollbar-track {
              background: #F8F9FB;
          }
      }
      .content {
        width: 100%;
        height: 180px;
        background-color: #f9f9f9;
        border: 0;
        outline: none;
        resize: none;
        padding: 16px 0 0 16px;
        box-sizing: border-box;
        color: #333333;
        font-size: 14px;
        border-radius: 3px;
      }
    }
    .img_list {
      width: 100%;
      box-sizing: border-box;
      margin-top: 20px;
      .item1 {
        width: 70px;
        height: 70px;
        display: inline-block;
        position: relative;
        margin-left: 10px;
        margin-top: 20px;
        img {
          width: 100%;
          height: 70px;
        }
        .canima {
          width: 100%;
          height: 100%;
        }
        .delect {
          width: 20px;
          height: 20px;
          position: absolute;
          right: 0;
          top: 0;
          background: rgba(0, 0, 0, 0.4);
          color: #fff;
          font-size: 20px;
          text-align: center;
          line-height: 20px;
          z-index: 999999;
        }
      }
      .item_active {
        position: relative;
        top: 0px;
      }
    }
   
  }
   .btn {
      width: 100%;
      padding: 8px 16px 34px;
      position: fixed;
      left: 0;
      bottom: 0;
      background-color: #fff;
      z-index: 2;
      box-shadow: 0 0 16px 0 rgba(0,0,0,0.05);
      
      span {
        width: 100%;
        display: inline-block;
        background-color: @base-color;
        opacity: 0.5;
        text-align: center;
        line-height: 48px;
        font-size: 16px;
        color: #fff;
        border-radius: 3px;
      }
      .active {
        opacity: 1;
      }
    }
}
</style>
<style>
/* .image-reader-item{
    width:60px!important;
    height:60px!important;
}
.md-tag .shape-quarter.size-small{
    width:26px;
    height:26px;
}
.md-image-reader, .md-image-reader-file{
    width:60px;
    height:60px;
}
.md-image-reader{
    width:60px;
    height:60px;
} */
</style>
